const fs = require('fs')
const path = require('path')
try {
    const data = fs.readFileSync('./text.json','utf-8')
    console.log(data)
} catch(e){

}